import { Chip } from "@mui/material";
import { Box } from "@mui/system";
import { MenuSelect } from "./MenuSelect";

interface ListSelectProps {
    id: string;
    size?: "small" | "medium";
    showSearch?: boolean
    showUnknownValue?: boolean;
    label: string;
    valueList: { [key: string]: string; };
    value: string[];
    onAdd?: (key: string) => void;
    onDelete: (key: string) => void;
    popoverExtra?: (handleClose: () => void) => React.ReactNode;
    popoverOnly?: boolean;
    chipColor?: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "default";
    // strikethrough marks individual chips (by the same key as valueList) as
    // struck through - e.g. a group filter whose group has since been hidden.
    strikethrough?: { [key: string]: boolean };
}

export function ListSelect(props: ListSelectProps) {
    return <>
        <Box sx={{ marginTop: "20px", width: "100%" }}>
            <MenuSelect
                id={props.id}
                showSearch={props.showSearch}
                size={props.size || "medium"}
                label={props.label}
                valueList={Object.entries(props.valueList).map(([key, value]) => {
                    return {
                        text: value,
                        value: key,
                        selected: props.value.includes(key),
                    };
                })}
                onItemSelected={x => props.onAdd && props.onAdd(x)}
                popoverExtra={(handleClose) => props.popoverExtra && props.popoverExtra(handleClose)}
                popoverOnly={props.popoverOnly} />
            <Box sx={{ marginTop: "10px", gap: "5px", display: "flex", flexWrap: "wrap", minHeight: "32px" }}>
                {props.value.map(x => {
                    let value = props.valueList[x];
                    if (value === undefined && props.showUnknownValue) {
                        value = x;
                    }

                    return <Chip
                        key={x}
                        label={value}
                        variant="outlined"
                        color={props.chipColor || "primary"}
                        onDelete={() => props.onDelete(x)}
                        sx={{ textDecoration: props.strikethrough?.[x] ? "line-through" : undefined }}
                    />;
                })}
            </Box>
        </Box>
    </>;
}
